import React from 'react';

import Typography from '@material-ui/core/Typography';
import styles from './styles.css';

export default function QueryCertifiedComments({ query = {} }) {

  return <>
    <div className={styles.sectionTitleWrapper}>
      <Typography style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '0px' }}>
        Comentários Certificado
      </Typography>
      <hr style={{ margin: 0, borderColor: '#8B8B8D', borderWidth: '1px' }} />
    </div>
    <p style={{ padding: '0rem 5px' }}>
      {query.observationCertificate || '-'}
    </p>
  </>;
}
